export default "__VITE_ASSET__e2069c4c__"